<!-- eslint-disable sonarjs/no-duplicate-string -->
<template>
  <Sect id="SectionProjects">
    <h2>Saulės parkai</h2>
    <div v-if="projects" class="mainContainer">
      <CardProject
        v-for="(project, index) in projects.slice(0, 6)"
        :key="index"
        :project="project" />
    </div>
    <div class="viewMore">
      <Route class="Btn arrow" to="SolarPlants">
        VISI SAULĖS PARKAI
      </Route>
    </div>
  </Sect>
</template>

<script>
import CardProject from './CardProject'
// import HorizontalScroll from './HorizontalScroll'
// import ProjectMocker from 'mixins/ProjectMocker'
import ProjectBundler from 'mixins/ProjectBundler'

export default {
  mixins: [ProjectBundler],
  components: { CardProject },
  computed: {
    projectsCount() {
      return this.projects.length
    },
  },
}
</script>

<style lang="scss">
#SectionProjects {
  background: $white-ter;
  margin: 0 2rem;
  // display: flex;
  position: relative;

  h2 {
    @include dotAbove(1.5rem);
    padding-bottom: 2rem;
  }

  .mainContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    position: relative;
  }

  .CardProject {
    flex: 1 1 85%; // mobile: full-ish width
    @include md {
      flex: 1 1 45%;
    }
    @include xl {
      flex: 1 1 30%;
    }
  }

  .viewMore {
    display: flex;
    justify-content: center;
    margin: 4rem 0;

    > a {
      width: 18rem;
    }
  }
}
</style>
